import React from "react";
import Animate from "@/components/animations/Animate";
import Flex from "@/components/layout/Flex";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { SlideProps } from "../types";

const slideVariants = {
  enter: {
    x: "100%",
    opacity: 0,
  },
  exit: {
    x: "100%",
    opacity: 0,
  },
  center: { x: 0, opacity: 1 },
};

function Slide({
  index,
  activeSlide,
  direction,
  className,
  children,
  ...props
}: SlideProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (index === 0) {
    return (
      <Animate
        as={Flex.Column}
        className={cn(
          "absolute inset-0 p-4 bg-popover z-10 overflow-y-auto",
          className,
          classes,
        )}
      >
        {children}
      </Animate>
    );
  }

  return (
    <Animate.Presence>
      {activeSlide === index && (
        <Animate
          key={index}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.25 }}
          className={cn(
            "absolute inset-0 p-4 bg-card z-10 flex flex-col justify-start items-start gap-4 overflow-y-auto",
            className,
            classes,
          )}
          {...native}
        >
          {children}
        </Animate>
      )}
    </Animate.Presence>
  );
}

export default Slide;
